import { useContext } from "react";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO Components
import DashboardLayout from "parts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "parts/Navbars/DashboardNavbar";
import Footer from "parts/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Calendar from "../../components/tasks/Calendar";

import { LanguageContext } from "context";

function TaskCalendar() {
  const { t } = useContext(LanguageContext) as any;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDTypography variant="h4" mb={2}>
          {t("TaskCalendar")}
        </MDTypography>
        <Card sx={{ mb: 3, p: 2 }}>
          <Calendar />
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TaskCalendar;
